import { DialogActions, DialogContent } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { ResponsiveDialog } from "components/ResponsiveDialog/ResponsiveDialog"
import { FormEvent, useState } from "react"
import { CaptureFoto } from "./CaptureFoto"

type CameraDialogProps = {
  open: boolean
  onClose: () => void
  onSave: (arg: FormEvent<HTMLFormElement>, img: string[]) => void
  imageName?: string
}

export const CameraDialog = (props: CameraDialogProps) => {
  const { open, onClose, onSave, imageName } = props
  const [fotos, setFotos] = useState<string[]>([])

  const onCapture = (image: string) => {
    setFotos([image])
  }

  const handleClose = () => {
    onClose()
    setFotos([])
  }

  const handleSaveFotos = (event: FormEvent<HTMLFormElement>) => {
    onSave(event, fotos)
    handleClose()
  }

  return (
    <ResponsiveDialog open={open}>
      <DialogContent sx={{ p: 1, display: "flex", flexDirection: "column" }}>
        <CaptureFoto
          handleSave={handleSaveFotos}
          onCapture={onCapture}
          fotos={fotos}
          setFotos={setFotos}
          imageName={imageName}
        />
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" fullWidth onClick={handleClose} variant="contained" />
      </DialogActions>
    </ResponsiveDialog>
  )
}
